// Port of menu_test products/chart.coffee getAnswer (116-187).
// ec's answer.js is only a structural template — the menu math differs (opened-percents
// subtraction, trait-branch subtraction, zero-total guards, plain no-action fallback).

import { formatAmount, calcUnitLabel } from '@aytm/app/stats/page/question-views/mn/lib/chart/format'
import { applyUnitTemplate } from '@aytm/app/stats/page/question-views/mn/lib/chart/answer-utils'
import { PRODUCT_PERCENT_CAPABLE_VIEWS, VIEW_MODES } from '@aytm/app/stats/page/question-views/mn/lib/viewOptions'

const PRODUCTS_SECONDS_MODES = [VIEW_MODES.TIME]

const isAnswerKey = key => key[0] === 'a' && !Number.isNaN(Number(key.slice(1)))

export const getProductsAnswer = ({ answer, answerVariants, viewMode, priceTemplate, trait, traitName }) => {
  // the N/A menu item is dropped from per-item charts
  const naKeys = new Set((answerVariants || []).filter(av => av.na).map(av => `a${av.position}`))

  const hcAnswers = { total: answer?.total || 0 }

  for (const ak of Object.keys(answer || {})) {
    if (!isAnswerKey(ak)) continue
    if (naKeys.has(ak)) continue

    const av = answer[ak]
    const value = {}
    hcAnswers[ak] = value

    value.amount = formatAmount(av[viewMode] || 0, viewMode)
    // shown rounded, sorted on the raw value the table sorts by, so values that round alike keep its order
    value.sortValue = Number(av[viewMode]) || 0
    if (PRODUCT_PERCENT_CAPABLE_VIEWS.includes(viewMode)) value.percents = av.percents || 0
    value.unitLabel = calcUnitLabel({
      viewMode,
      amount: value.amount,
      percentCapableViews: PRODUCT_PERCENT_CAPABLE_VIEWS,
      secondsModes: PRODUCTS_SECONDS_MODES
    })
    applyUnitTemplate(value, viewMode, priceTemplate)
    if (PRODUCT_PERCENT_CAPABLE_VIEWS.includes(viewMode) && av.errLO && av.errHI) {
      value.errLO = av.errLO
      value.errHI = av.errHI
    }

    if (trait) {
      const traitBlock = {}
      // coffee's `for tk of undefined` silently iterates zero times — guard for JS
      const avTrait = av[traitName] || {}
      for (const tk of Object.keys(avTrait)) {
        const tv = avTrait[tk]
        const traitValue = {
          amount: formatAmount(tv[viewMode] || 0, viewMode),
          unitLabel: value.unitLabel
        }
        if (PRODUCT_PERCENT_CAPABLE_VIEWS.includes(viewMode)) traitValue.percents = tv.percents || 0
        applyUnitTemplate(traitValue, viewMode, priceTemplate)
        traitBlock[tk] = traitValue
      }
      value[traitName] = traitBlock
    }
  }

  return hcAnswers
}
